// 复制图片到剪贴板，非 PNG 图片会先转换为 PNG
export async function copyImageToClipboard(url) {
	const res = await fetch(url);
	if (!res.ok) {
		throw new Error('image fetch failed: ' + res.status);
	}
	let blob = await res.blob();
	if (blob.type !== 'image/png') {
		blob = await convertToPng(blob);
	}
	await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
}

function convertToPng(blob) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		const objectUrl = URL.createObjectURL(blob);
		img.onload = () => {
			const canvas = document.createElement('canvas');
			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;
			canvas.getContext('2d').drawImage(img, 0, 0);
			URL.revokeObjectURL(objectUrl);
			canvas.toBlob((pngBlob) => (pngBlob ? resolve(pngBlob) : reject(new Error('canvas toBlob failed'))), 'image/png');
		};
		img.onerror = (err) => {
			URL.revokeObjectURL(objectUrl);
			reject(err);
		};
		img.src = objectUrl;
	});
}
